import { getAxiosInstance } from "../../../api";

export const canceVerificationRange = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(
      `/verification/certificate-status-change`,
      params,
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};
export const cancelVerificationSelect = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/verification/certificate-cancel`, params);
    return res;
  } catch (error) {
    return error.response.data;
  }
};
export const submitBarcodeWork = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/verification/barcode-data-generator`, params);
    return res;
  } catch (error) {
    return error.response.data;
  }
};
